import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ProjectDetails } from "./styles";
import { projectsData } from "../../pages/Projects/Data/projectsData";
import { fadeInMotion } from "../../framer/animation";
import { motion } from "framer-motion";

const CardExpanded = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [disabled, setDisabled] = useState(false);
	const goBack = (e) => {
		const element = e.target;
		if (element.classList.contains("overlay")) {
			navigate(-1);
			document.body.style.overflow = "auto";
		}
	};

	return (
		<ProjectDetails
			variants={fadeInMotion}
			initial='hidden'
			animate='show'
			exit='exit'
			className='overlay'
			onClick={goBack}
		>
			<motion.div className='project-detail'>
				<div className='btn__container-light'>
					<button
						disabled={disabled}
						onClick={() => {
							document.body.style.overflow = "auto";
							navigate(-1);
							setDisabled(true);
						}}
						className='light'
					>
						Go back
					</button>
				</div>
				<div className='project-name'>
					<h3>{projectsData[id - 1].name}</h3>
				</div>
				<div className='img__container'>
					<img
						src={projectsData[id - 1].thumb}
						alt={projectsData[id - 1].name}
					/>
				</div>
				<div className='desc__container'>
					<p>{projectsData[id - 1].description}</p>
				</div>
				<div className='skills__container'>
					<ul className='stack'>
						{projectsData[id - 1].stack.map((st) => (
							<li key={st[1]}>{st}</li>
						))}
					</ul>
				</div>
				<div className='btn__container'>
					<button>
						<a
							target='_blank'
							rel='noreferrer'
							href={projectsData[id - 1].githubLink}
						>
							Source Code
						</a>
					</button>
					<button>
						<a
							target='_blank'
							rel='noreferrer'
							href={projectsData[id - 1].demoLink}
						>
							Live demo
						</a>
					</button>
					{projectsData[id - 1].usefulUrl ? (
						<button>
							<a
								target='_blank'
								rel='noreferrer'
								href={projectsData[id - 1].usefulUrl}
							>
								{projectsData[id - 1].usefulUrlName}
							</a>
						</button>
					) : (
						""
					)}
				</div>
			</motion.div>
		</ProjectDetails>
	);
};

export default CardExpanded;
